module.exports = __webpack_public_path__ + "static/img/sy-1.d6ddbbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-1.png
// module id = nybm
// module chunks = 63